import React, { Component } from 'react';
import {SearchBar, Tabs, List, Flex, WingBlank, Toast} from 'antd-mobile';
import _ from 'lodash'
import send from '../../../utils/send';
import ListImg from '../../../components/ListImg'
const  TITLE = {
  feed: '饲料',
  medicine: '兽药',
  vaccine:'疫苗',
  semen:'精液',
  pig:'肥猪',
  fswine:'母猪',
  mswine:'公猪',
  cpig:'仔猪'
};
export default class ProductList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      tab: 0,
      resData: [],
      list:{
        feed:[],
        medicine:[],
        vaccine:[],
        semen:[],
        cpig: {
        },
        pig: {
        },
        fswine: {
        },
        mswine: {
        }
      },
      tabs: [
        { title: '全部'},
        { title: '饲料' },
        { title: '兽药' },
        { title: '疫苗' },
        { title: '精液' },
        { title: '猪只' }
      ]
    }
  }
  componentDidMount() {
    this.doSearchData = _.debounce(v => {
      this.doSearch(v)
    }, 500);
    this.getData()
  }
  getData = () => {
    Toast.loading('加载中',5);
    send({
      url: '/api/forward/ifarm/initInfo/list',
      method: 'get'
    }).then(res => {
      Toast.hide();
      const data = {
        feed:[],
        medicine:[],
        vaccine:[],
        semen:[],
        cpig: {
        },
        pig: {
        },
        fswine: {
        },
        mswine: {
        },
        ...res.data.data
      };
      this.setState({
        list: data,
        resData: data
      })
    })
  };
  renderList = (type) => {
    const {list} = this.state;
    return <React.Fragment>
      <div style={{fontSize: 16,padding: '8px 10px 0'}}>{TITLE[type]}</div>
      {list[type].map((o,index) => (
        <Flex className={'round-list'}
            justify={'between'}
            wrap={'nowrap'}
            style={{backgroundColor: '#fff',padding: '10px 10px',fontSize: 12,borderBottom: '1px solid #eee'}}
            key={index}
        >
          <Flex>
            <span>{o.productName}</span>
            <span className={'bag'}>{o.unitName}</span>
          </Flex>
          <Flex>
            <b>{o.calculateMethod === 'Q'? '数量': '重量'}:</b>
            <b style={{padding: '0 5px'}}>{o.qty}</b>
            <b>{o.unitName}</b>
          </Flex>
        </Flex>
      ))}
      {/*{list[type].length === 0 && <ListImg height={50} />}*/}
      {list[type].length === 0 && <p style={{textAlign:'center'}} className={'text-2'}>暂无数据</p>}
    </React.Fragment>
  };
  doSearch = (v) => {
    console.log('search  ',v);
    const {resData} = this.state;
    const arr = ['feed', 'medicine', 'vaccine', 'semen'];
    console.log(arr);
    let data = {};
    for (var i = 0; i < arr.length; i++) {
      var type = arr[i];
      data[type] = resData[type].filter(o => (o.productName.indexOf(v) >=0))
    }
    this.setState({
      list: {
        ...data,
        cpig: resData.cpig,
        pig: resData.pig,
        fswine: resData.fswine,
        mswine: resData.mswine
      }
    })

  };
  renderPig = (type) => {
    const {list} = this.state;
    const data = list[type];
    return <List>
      <Flex className={'round-list'}
          justify={'between'}
          wrap={'nowrap'}
          style={{backgroundColor: '#fff',padding: '10px 10px',fontSize: 12,borderBottom: '1px solid #eee'}}
      >
        <Flex>
          <span>{TITLE[type]}</span>
          <span className={'bag'}>头</span>
        </Flex>
        <Flex>
          <b style={{padding: '0 5px'}}>数量：</b>
          <b style={{padding: '0 5px'}}>{data.stock || '0'}</b>
          <b>头</b>
        </Flex>
      </Flex>
    </List>
  };
  render() {
    const {tabs, tab} = this.state;
  return (
    <React.Fragment>
      <SearchBar placeholder={'点击搜索商品名称'}
          onChange={v => {
        this.doSearchData(v)
      }}
      />
      <div style={{height: 44}}>
        <Tabs tabs={tabs}
            initialPage={0}
            onTabClick={(tab, index) => {
                this.setState({tab: index})
              }}
        />
      </div>
      <WingBlank size={'md'}>
        {
          tab===0 && (
            <div>
              {this.renderList('feed')}
              {this.renderList('medicine')}
              {this.renderList('vaccine')}
              {this.renderList('semen')}
              <div style={{fontSize: 16,padding: '5px 10px'}}>猪只</div>
              {this.renderPig('mswine')}
              {this.renderPig('fswine')}
              {this.renderPig('cpig')}
              {this.renderPig('pig')}
            </div>
          )
        }
        {tab===1 && this.renderList('feed')}
        {tab===2 && this.renderList('medicine')}
        {tab===3 && this.renderList('vaccine')}
        {tab===4 && this.renderList('semen')}
        {
          tab === 5 && <React.Fragment>
            <div style={{fontSize: 16,padding: '5px 10px'}}>猪只</div>
            {this.renderPig('mswine')}
            {this.renderPig('fswine')}
            {this.renderPig('cpig')}
            {this.renderPig('pig')}
          </React.Fragment>
        }
      </WingBlank>

    </React.Fragment>
  )
 }
}
